/* creates a new board */
export const boardCreate = async (title: string, description: string) =>
  fetch('/api/secure/boards/create', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ title, description }),
  }).then((e) => e.json());

/* deletes existing board */
export const boardDelete = async (encodedId: string) =>
  fetch(`/api/secure/boards/${encodedId}/delete`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

/* modifies existing board */
export const boardModify = async (
  encodedId: string,
  title: string,
  description: string,
  coverUri: string,
  isPrivate: boolean
) =>
  fetch(`/api/secure/boards/${encodedId}/modify`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ title, description, coverUri, isPrivate }),
  }).then((e) => e.json());

export const boardTokenAdd = async (boardid: string, tokenid: string) =>
  fetch(`/api/secure/boards/${boardid}/add`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ tokenid }),
  }).then((e) => e.json());

export const boardTokenRemove = async (boardid: string, tokenid: string) =>
  fetch(`/api/secure/boards/${boardid}/remove`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ tokenid }),
  }).then((e) => e.json());

export const boardLoadDraft = async (boardId: string) =>
  fetch(`/api/public/boards/${boardId}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
